import type { HTMLAttributes, ReactNode, Ref } from "react";
import { cx } from "@/utils/cx";

interface HintTextProps extends Omit<HTMLAttributes<HTMLParagraphElement>, "slot"> {
    /** Indicates that the hint text is an error message. */
    isInvalid?: boolean;
    ref?: Ref<HTMLParagraphElement>;
    slot?: string | null;
    size?: "sm" | "md";
    children: ReactNode;
}

export const HintText = ({ isInvalid, className, size = "md", slot: _slot, ...props }: HintTextProps) => {
    return (
        <p
            {...props}
            data-slot={isInvalid ? "error-message" : "description"}
            aria-live={isInvalid ? "polite" : undefined}
            className={cx(
                "text-sm text-muted-foreground",

                // Size
                size === "sm" && "text-xs",
                "in-data-[input-size=sm]:text-xs",

                // Invalid state
                isInvalid && "text-destructive",
                "group-invalid:text-destructive",

                className,
            )}
        />
    );
};

HintText.displayName = "HintText";
